import {
  EDealType,
  EEntityType,
} from '../../repositories/favorites/entities/delete_user_favorites/DeleteOfferFromFavoritesRequestSchema';
import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesResponse,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';

import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../utils/errors';

export type TDeleteFromFavoriteParameters = {
  offerId: number;
};

export async function deleteFromFavorite(
  context: IApplicationContext,
  parameters: TDeleteFromFavoriteParameters,
): Promise<void> {
  const { logger, httpApi } = context;
  const { offerId } = parameters;

  try {
    const response: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
      httpApi,
      parameters: {
        entityId: offerId,
        dealType: EDealType.Sale,
        entityType: EEntityType.OfferResidental,
      },
    });

    if (response.statusCode !== 200) {
      /* istanbul ignore next */
      throw new ResponseError({
        domain: 'deleteFromFavorite',
        message: response.response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }
  } catch (error) {
    logger.error(error, {
      offerId,
      domain: 'deleteFromFavorite',
    });

    throw error;
  }
}
